import { TitanButton } from "@lib/titan2/dist/game/control/TitanButton";
import { TitanPanel } from "@lib/titan2/dist/game/control/TitanPanel";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { Slingo } from "../../../../api/Slingo";
import { ChooseCellParams } from "../../../../api/choosecell/ChooseCellParams";
import { CollectParams } from "../../../../api/collect/CollectParams";
import { CurrentGameParams } from "../../../../api/currentgame/CurrentGameParams";
import { SpinResultData } from "../../../../api/model/data/SpinResultData";
import { SymbolWinData } from "../../../../api/model/data/SymbolWinData";
import { SymbolType } from "../../../../api/model/enum/SymbolType";
import { PurchaseEntryParams } from "../../../../api/purchase/PurchaseEntryParams";
import { SpinParams } from "../../../../api/spin/SpinParams";
import { SlingoEvent, TestEvent } from "../../../controller/event/SlingoEvent";
import { AbstractGameView } from "./AbstractGameView";
/**
 * Test.ts
 */
export class Test extends AbstractGameView {
    create() {
        super.create();
        this.panel = TitanPanel.createPanel(this, "testPanel", this.landscapeProperties.panelProperties, this.portraitProperties?.panelProperties);
        this.createButtons();
        this.panel.arrange();
        this.initKeyboardEvents();
        Logger.addObjectRef(this, "Test");
    }
    createButtons() {
        this.createTestButton("Current Game", this.handleCurrentGameButtonSelected);
        this.createTestButton("Purchase Entry", this.handlePurchaseEntryButtonSelected);
        this.createTestButton("Spin", this.handleSpinButtonSelected);
        this.createTestButton("Choose Cell", this.handleChooseCellButtonSelected);
        this.createTestButton("Collect", this.handleCollectButtonSelected);
        this.createTestButton("Big Win", this.handleBigWinButtonSelected);
        this.createTestButton("Full House", this.handleFullHouseButtonSelected);
        this.createTestButton("Joker Win", this.handleSymbolWinButtonSelected);
        this.createTestButton("Game Summary", this.handleGameSummarySelected);
        this.createTestButton("Game Over", this.handleGameOverSelected);
        this.createTestButton("1 Slingo", this.handleSlingo1Selected);
        this.createTestButton("2 Slingos", this.handleSlingo2Selected);
        this.createTestButton("3 Slingos", this.handleSlingo3Selected);
        this.createTestButton("4 Slingos", this.handleSlingo4Selected);
    }
    createTestButton(text, handler) {
        let button = new TitanButton(this.landscapeProperties.testButtonProperties, this.portraitProperties?.testButtonProperties);
        button.onClick(handler, this);
        button.setText(text);
        this.panel.addToPanel(button, false);
    }
    handleCurrentGameButtonSelected() {
        Logger.debug("Current Game!");
        let params = new CurrentGameParams(this.model.getRoomName());
        Slingo.getCurrentGame(params, this.handleComplete, this);
    }
    handlePurchaseEntryButtonSelected() {
        Logger.debug("Purchase Entry!");
        let params = new PurchaseEntryParams("GBP", 1, 1);
        Slingo.purchaseEntry(params, this.handleComplete, this);
    }
    handleSpinButtonSelected() {
        Logger.debug("SPIN!");
        let params = new SpinParams(false);
        Slingo.spin(params, this.handleComplete, this);
    }
    handleChooseCellButtonSelected() {
        Logger.debug("Choose Cell!");
        let params = new ChooseCellParams(50, false);
        Slingo.chooseCell(params, this.handleComplete, this);
    }
    handleCollectButtonSelected() {
        Logger.debug("Collect!");
        let params = new CollectParams(false);
        Slingo.collect(params, this.handleComplete, this);
    }
    handleBigWinButtonSelected() {
        this.updateBigWinResult();
        this.dispatchGame(SlingoEvent.BIG_WIN_ANIMATION_PHASE_ONE);
    }
    handleFullHouseButtonSelected() {
        this.updateFullHouseResult();
        this.dispatchGame(SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_ONE);
    }
    handleSymbolWinButtonSelected() {
        this.updateSymbolWinResult();
        this.dispatchGame(SlingoEvent.SCATTER_WIN_ANIMATION);
    }
    updateSymbolWinResult() {
        this.updateStandardResult();
        let result = this.model.getSpinResult();
        if (!result) {
            const winData = new SymbolWinData(undefined);
            winData.setNumberOfSymbols(3);
            winData.setAmount(400);
            winData.setType(SymbolType.JOKER);
            result = new SpinResultData(undefined);
            const symbolWins = new Dictionary();
            symbolWins.setValue(SymbolType.JOKER, winData);
            result.symbolWins = symbolWins;
        }
    }
    updateFullHouseResult() {
        this.updateStandardResult();
        let result = this.model.getResultData();
        result.setFullHouse(true);
    }
    updateBigWinResult() {
        this.updateStandardResult();
        let result = this.model.getResultData();
        result.setBigWin(true);
        this.model.setTotalWin(9999);
        let payoutConfig = this.model.getPayoutConfig();
        result.setMatchedPatterns(payoutConfig.getPatterns());
    }
    handleGameSummarySelected() {
        this.updateStandardResult();
        this.dispatchGame(TestEvent.GAME_SUMMARY);
    }
    handleGameOverSelected() {
        this.dispatchGame(TestEvent.GAME_OVER);
    }
    handleSlingo1Selected() {
        this.dispatchGame(TestEvent.SLINGO_1);
    }
    handleSlingo2Selected() {
        this.dispatchGame(TestEvent.SLINGO_2);
    }
    handleSlingo3Selected() {
        this.dispatchGame(TestEvent.SLINGO_3);
    }
    handleSlingo4Selected() {
        this.dispatchGame(TestEvent.SLINGO_4);
    }
    updateStandardResult() {
        let result = this.model.getResultData();
        result.reset();
        let jokerWin = new SymbolWinData();
        jokerWin.setAmount(300);
        jokerWin.setType(SymbolType.JOKER);
        jokerWin.setNumberOfSymbols(3);
        let coinWin = new SymbolWinData();
        coinWin.setAmount(20);
        coinWin.setType(SymbolType.COIN);
        coinWin.setNumberOfSymbols(3);
        result.setCoinWin(coinWin);
        result.setJokerWin(jokerWin);
        result.setSlingoWin(1200);
        result.setNoWin(false);
        result.setSymbolWin(100);
    }
    handleComplete() {
        Logger.debug("Complete Request!");
    }
    initKeyboardEvents() {
        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey && event.code === 'KeyO') {
                event.preventDefault();
                this.panel.visible = !this.panel.visible;
            }
        });
    }
}
//# sourceMappingURL=Test.js.map